import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ReactCountryFlag from "react-country-flag";
import { useI18n } from "@/lib/i18n";
import { cn } from "@/lib/utils";

export function LanguageToggle() {
  const { locale, setLocale, t } = useI18n();

  const options = [
    { value: "en", label: t("language.english"), countryCode: "US" },
    { value: "id", label: t("language.indonesian"), countryCode: "ID" },
  ] as const;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-9 px-2 text-xs font-semibold gap-1"
          aria-label={t("language.toggle")}
        >
          <ReactCountryFlag
            countryCode={locale === "en" ? "US" : "ID"}
            svg
            style={{ width: "1.1em", height: "1.1em" }}
            aria-hidden="true"
          />
          {locale.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onSelect={() => setLocale(option.value)}
            className={cn(
              "flex items-center justify-between",
              locale === option.value && "font-semibold text-foreground"
            )}
          >
            <span className="inline-flex items-center gap-2">
              <ReactCountryFlag
                countryCode={option.countryCode}
                svg
                style={{ width: "1.1em", height: "1.1em" }}
                aria-label={option.label}
              />
              <span>{option.label}</span>
            </span>
            {locale === option.value ? "✓" : ""}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
